import React from "react";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";

interface Props {
  eventData: any;
}

const ExperienceDetail = ({ eventData }: Props) => {
  const formattedStartDate = eventData?.start
    ? new Intl.DateTimeFormat("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      }).format(new Date(eventData.start))
    : "";

  const formattedEndDate = eventData?.end
    ? new Intl.DateTimeFormat("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      }).format(new Date(eventData.end))
    : "";

  const formattedStartTime = eventData?.start
    ? new Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      }).format(new Date(eventData.start))
    : "";

  const formattedEndTime = eventData?.end
    ? new Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      }).format(new Date(eventData.end))
    : "";

  return (
    <div className="w-full lg:w-[750px]">
      {/* Event Images */}
      {eventData?.media && eventData.media.length > 0 && (
        <div className="mt-8 flex items-center gap-4 flex-wrap">
          {eventData.media.slice(0, 4).map((media: any, index: number) => (
            <img
              key={index}
              className="w-[125px] h-[110px] rounded-lg object-cover"
              src={concatPathWithBackendUrl(media.name)}
              alt={`Event image ${index + 1}`}
            />
          ))}
        </div>
      )}

      {/* Description */}
      <div className="mt-8 flex flex-wrap  items-center gap-8">
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Name
          </span>
          <span className="text-xs text-tertiaryText">
            {eventData?.name || "-"}
          </span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Event Type
          </span>
          <span className="text-xs text-tertiaryText">
            {eventData?.eventType || "-"}
          </span>
        </div>
      </div>

      {/* Description */}
      <div className="mt-8 flex flex-wrap  items-center gap-4">  
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Description
          </span>
          <span className="text-xs text-tertiaryText">
            {eventData?.description || "-"}
          </span>
        </div>
      </div>

      {/* Date and Time Info */}
      <div className="mt-8 flex flex-wrap justify-between items-center gap-4">
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Start Date
          </span>
          <span className="text-xs text-tertiaryText">
            {formattedStartDate || "-"}
          </span>
        </div>

        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Start Time
          </span>
          <span className="text-xs text-tertiaryText">
            {formattedStartTime || "-"}
          </span>
        </div>

        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            End Date
          </span>
          <span className="text-xs text-tertiaryText">
            {formattedEndDate || "-"}
          </span>
        </div>

        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            End Time
          </span>
          <span className="text-xs text-tertiaryText">
            {formattedEndTime || "-"}
          </span>
        </div>
      </div>

      {/* Meeting Link */}
      {eventData?.meeting_link && eventData.meeting_link !== "string" && (
        <div className="mt-8 flex flex-wrap justify-between items-center gap-4">
          <div className="flex flex-col gap-4">
            <span className="text-sm font-semibold text-captionText">
              Meeting Link
            </span>
            <a
              href={eventData.meeting_link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-blue-600 hover:underline"
            >
              {eventData.meeting_link}
            </a>
          </div>
        </div>
      )}

      {/* Created At */}
      <div className="mt-8 flex flex-wrap justify-between items-center gap-4">
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Created At
          </span>
          <span className="text-xs text-tertiaryText">
            {eventData?.createdAt
              ? new Intl.DateTimeFormat("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  hour: "numeric",
                  minute: "numeric",
                  hour12: true,
                }).format(new Date(eventData.createdAt))
              : "-"}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ExperienceDetail;
